import { Link } from 'react-router-dom';
import Logo from '../common/Logo';

const footerLinks = {
  product: [
    { name: 'Features', href: '/#features' },
    { name: 'Pricing', href: '/pricing' },
    { name: 'Platform Security', href: '/security' },
    { name: 'Trust & Compliance', href: '/trust' },
  ],
  company: [
    { name: 'About', href: '/about' },
    { name: 'Contact', href: '/about#contact' },
  ],
  legal: [
    { name: 'Privacy Policy', href: '/privacy' },
    { name: 'Cookie Policy', href: '/cookie-policy' },
    { name: 'Terms of Service', href: '/terms' },
    { name: 'Responsible Disclosure', href: '/responsible-disclosure' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-slate-50 dark:bg-slate-900 border-t border-slate-200 dark:border-slate-800">
      <div className="mx-auto max-w-7xl px-6 py-12 lg:px-8">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
          <div className="col-span-2 md:col-span-1">
            <Logo />
            <p className="mt-4 text-sm text-slate-500 dark:text-slate-400">
              The Cloud Security Posture Auditor for Microsoft 365 and Google Workspace.
            </p>

            {/* Cyber Essentials Certification badge */}
            <a
              href="/cyber-essentials-certificate.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-6 inline-flex items-center gap-3 rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 px-3 py-2 hover:border-primary-500 dark:hover:border-primary-400 transition-colors"
              aria-label="View Cyber Essentials Certificate (PDF)"
            >
              <img
                src="/cyber-essentials-badge.png"
                alt="Cyber Essentials Certified"
                className="h-14 w-auto flex-shrink-0"
              />
              <div className="flex flex-col leading-tight">
                <span className="text-xs font-semibold text-slate-900 dark:text-white">
                  Cyber Essentials Certified ✅
                </span>
                <span className="text-[11px] text-slate-500 dark:text-slate-400">
                  Cyber Essentials Plus in progress
                </span>
                <span className="text-[10px] text-slate-400 dark:text-slate-500 mt-0.5">
                  View certificate (PDF)
                </span>
              </div>
            </a>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-slate-900 dark:text-white">Product</h3>
            <ul className="mt-4 space-y-3">
              {footerLinks.product.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-sm text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-slate-900 dark:text-white">Company</h3>
            <ul className="mt-4 space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-sm text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-slate-900 dark:text-white">Legal</h3>
            <ul className="mt-4 space-y-3">
              {footerLinks.legal.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-sm text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Company / registration details */}
        <div className="mt-12 border-t border-slate-200 dark:border-slate-800 pt-8">
          <div className="text-center text-sm text-slate-500 dark:text-slate-400 space-y-1">
            <p className="font-semibold text-slate-700 dark:text-slate-300">CyberActions Limited</p>
            <p>6th Floor, 66 Paul Street, London, EC2A 4NE</p>
            <p>Company No: 17149357 &middot; Registered in England and Wales</p>
            <p>
              <a
                href="mailto:contact@cyberactions.co.uk"
                className="text-primary-600 dark:text-primary-400 hover:underline"
              >
                contact@cyberactions.co.uk
              </a>
            </p>
          </div>
          <p className="mt-6 text-center text-sm text-slate-500 dark:text-slate-400">
            &copy; {new Date().getFullYear()} CyberActions Limited. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
